<template>
  <main-layout>
    <iframe
      sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
      allow="clipboard-read; clipboard-write"
      allowfullscreen="true"
      :src="src"
      :style="{
        display: 'block',
        border: 'none',
        position: 'absolute',
        width: '100%',
        height: 'calc(100dvh - var(--nav-height))'
      }"
    />
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['currentLang']),
    src() {
      if (!this.currentLang) return ''
      return `https://cms.enterprise.zwiz.app/${this.currentLang}/message-template-iframe`
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    async handleMessage(event) {
      const { event_id } = event.data
      switch (event_id) {
        case 'message-template-facebook-access-token-expired': {
          await this.$store.dispatch('logout')
          const url = new URL(window.location.origin)
          url.pathname = `/${this.currentLang}/login`
          window.location.href = url.toString()
          break
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/message-template-iframe/MessageTemplateIframe.vue